var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.33319 14.7142C6.75398 14.7142 7.0951 14.3731 7.0951 13.9523C7.0951 13.5315 6.75398 13.1904 6.33319 13.1904C5.91241 13.1904 5.57129 13.5315 5.57129 13.9523C5.57129 14.3731 5.91241 14.7142 6.33319 14.7142Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0948 14.7142C15.3052 14.7142 15.4758 14.3731 15.4758 13.9523C15.4758 13.5315 15.3052 13.1904 15.0948 13.1904C14.8844 13.1904 14.7139 13.5315 14.7139 13.9523C14.7139 14.3731 14.8844 14.7142 15.0948 14.7142Z",
    stroke: "#FBFBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H3.5176L5.4058 11.6667H15.4762",
    stroke: "#FBFBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.03534 9.38058H15.5902C15.6611 9.38064 15.7298 9.3532 15.7846 9.30296C15.8394 9.25271 15.877 9.18276 15.8909 9.10501L16.9941 2.93358C17.003 2.88382 17.0019 2.83246 16.9909 2.78322C16.9799 2.73399 16.9593 2.68809 16.9305 2.64885C16.9018 2.60961 16.8656 2.57801 16.8246 2.55632C16.7836 2.53463 16.7388 2.5234 16.6934 2.52344H4.80957",
    stroke: "#FBFBFB",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.27326c876487ca124db2872d530a14c7.svg";
export { ForwardRef as ReactComponent };